import produce from 'immer';
import {
  RECEIVE_SCENARIO_OPTIONS,
  REQUEST_SCENARIO_OPTIONS,
  SET_ENTITY_IDS,
  REQUEST_INVEST_PLATFORM,
  RECEIVE_INVEST_PLATFORM,
  REQUEST_SCENARIO_ENTITY_IDS,
  RECEIVE_SCENARIO_ENTITY_IDS,
  REQUEST_SCENARIO_STATE,
  RECEIVE_SCENARIO_STATE,
  REQUEST_DELETE_SCENARIO_ENTITIES,
  RECEIVE_DELETE_SCENARIO_ENTITIES,
  REQUEST_SUBMIT_SCENARIO_ENTITIES,
  RECEIVE_SUBMIT_SCENARIO_ENTITIES,
  SET_RESPONSE_ENTITY_IDS,
} from './actions';

const defaultState = {
  fetchingScenarioEntityIds: false,
  fetchingScenarioState: false,
  fetchingSubmitScenarioEntities: false,
  fetchingDeleteScenarioEntities: false,
  fetchingInvestPlatform: false,
  investPlatform: null,
  fetchingOptions: false,
  options: [],
  entityIds: null,
  responseEntityIds: null,
};

export default produce((state = defaultState, action) => {
  switch (action.type) {
    case REQUEST_SCENARIO_ENTITY_IDS: {
      state.fetchingScenarioEntityIds = true;
      break;
    }
    case RECEIVE_SCENARIO_ENTITY_IDS: {
      state.fetchingScenarioEntityIds = false;
      break;
    }
    case REQUEST_SCENARIO_STATE: {
      state.fetchingScenarioState = true;
      break;
    }
    case RECEIVE_SCENARIO_STATE: {
      state.fetchingScenarioState = false;
      break;
    }
    case REQUEST_DELETE_SCENARIO_ENTITIES: {
      state.fetchingDeleteScenarioEntities = true;
      break;
    }
    case RECEIVE_DELETE_SCENARIO_ENTITIES: {
      state.fetchingDeleteScenarioEntities = false;
      break;
    }
    case REQUEST_SUBMIT_SCENARIO_ENTITIES: {
      state.fetchingSubmitScenarioEntities = true;
      break;
    }
    case RECEIVE_SUBMIT_SCENARIO_ENTITIES: {
      state.fetchingSubmitScenarioEntities = false;
      break;
    }
    case REQUEST_INVEST_PLATFORM: {
      state.fetchingInvestPlatform = true;
      state.investPlatform = defaultState.investPlatform;
      break;
    }
    case RECEIVE_INVEST_PLATFORM: {
      state.fetchingInvestPlatform = false;
      state.investPlatform = action.value ?? null;
      break;
    }
    case REQUEST_SCENARIO_OPTIONS: {
      state.fetchingOptions = true;
      state.options = defaultState.options;
      break;
    }
    case RECEIVE_SCENARIO_OPTIONS: {
      state.fetchingOptions = false;
      state.options = action.value ?? [];
      break;
    }
    case SET_ENTITY_IDS: {
      state.entityIds = action.value;
      break;
    }
    case SET_RESPONSE_ENTITY_IDS: {
      state.responseEntityIds = action.value;
      break;
    }
    default:
      return state;
  }
});
